import React, { Fragment } from "react";
import { Divider, Form, Icon } from "antd";
import moment from "moment";
import Customer from "../../../common/FormSections/Customer";
import Phone from "../../../common/FormSections/Phone";
import Email from "../../../common/FormSections/Email";
import ServiceType from "../../../common/FormSections/ServiceType";
import Monetization from "../../../common/FormSections/Monetization";
import RequestNumber from "../common/sections/RequestNumber";
import OfferNumber from "../common/sections/OfferNumber";
import { CarrierComment } from "../common/sections/CarrierComment";
import Routes from "../../../common/FormSections/Routes";
import Performer from "../../../common/FormSections/Performer";
import AdditionalServices from "../../../common/FormSections/AdditionalServices";
import PriceFinal from "../../../common/FormSections/Price/PriceFinal";
import PriceFinalNDS from "../../../common/FormSections/Price/PriceFinalNDS";
import TotalPrice from "../../../common/FormSections/Price/TotalPrice";
import PriceNoNds from "../../../common/FormSections/Price/PriceNoNds";
import OfferPaymentType from "../../../common/FormSections/OfferPaymentType";
import SurchargePayment from "../../../common/FormSections/SurchargePayment";
import SurchargePaymentDate from "../../../common/FormSections/SurchargePaymentDate";
import RefundFreighterDate from "../../../common/FormSections/RefundFreighterDate";
import OfferDocuments from "../../../common/FormSections/OfferDocuments";
import Dispatcher from "../../../common/FormSections/Dispatcher";
import VehicleTypes from "../../../common/FormSections/VehicleTypes";
import Vehicle from "../../../common/FormSections/Vehicle";
import Drivers from "../../../common/FormSections/Drivers";
import MonetizationTemplates from "../../../common/FormSections/MonetizationTemplates";
import OfferEndDateTime from "../../../common/FormSections/OfferEndDateTime";

class OfferInfo extends React.Component {
  state = {
    showAllFields: false,
    monetizationFieldsDisabled: false,
    monetizationSectionPass: false
  };
  handleClickShowAllFields = () => {
    this.setState(state => ({ showAllFields: !state.showAllFields }));
  };

  checkCompleted = name => {
    return this.props.formProgress.some(
      f => f.name === name && f.completed === true
    );
  };

  toggleMonetizationFields = value => {
    this.setState({
      monetizationFieldsDisabled: value
    });
  };

  passMonetizationSection = () => {
    this.setState(
      {
        monetizationSectionPass: !this.state.monetizationSectionPass
      },
      () => {
        this.props.form.setFieldsValue({
          monetizationIsPassed: this.state.monetizationSectionPass
        });
      }
    );
  };

  render() {
    const {
      typeForm,
      form,
      isEditable,
      componentRef,
      handleClickShowAllFields,
      showAllFields
    } = this.props;
    const { monetizationFieldsDisabled } = this.state;
    const totalPrice = form.getFieldValue("totalPrice");
    const sumUndestributedPrice = (
      totalPrice,
      paySum = 0,
      predPaySum = 0,
      postPaySum = 0
    ) => {
      if (totalPrice) {
        return totalPrice - predPaySum - paySum - postPaySum;
      } else {
        return null;
      }
    };
    const predPaySum =
      form.getFieldValue("predPay") &&
      form.getFieldValue("predPay").length > 0 &&
      form
        .getFieldValue("predPay")
        .map(item =>
          form.getFieldValue("predPayPrice" + item)
            ? parseInt(form.getFieldValue("predPayPrice" + item))
            : 0
        )
        .reduce((acc, curr) => acc + curr);
    const paySum = form.getFieldValue("payPrice");
    const postPaySum =
      form.getFieldValue("postPay") &&
      form.getFieldValue("postPay").length > 0 &&
      form
        .getFieldValue("postPay")
        .map(item =>
          form.getFieldValue("postPayPrice" + item)
            ? parseInt(form.getFieldValue("postPayPrice" + item))
            : 0
        )
        .reduce((acc, curr) => acc + curr);

    return (
      <div className="card-info">
        <Form layout="inline">
          {typeForm === "view" ? (
            <>
              <RequestNumber form={form} disabled={true} />
              <OfferNumber
                form={form}
                disabled={true}
                componentRef={componentRef}
                handleClickShowAllFields={handleClickShowAllFields}
              />
              <Customer form={form} disabled={true} />
              <Phone form={form} disabled={true} />
              <Email form={form} disabled={true} />
              <ServiceType form={form} disabled={true} />
              <Divider />
              <Routes form={form} disabled={!isEditable} />
              <Divider />
              <Performer
                form={form}
                disabled={!isEditable}
                additionalComponent={
                  typeForm === "view" && (
                    <div className="show-all">
                      <div
                        className="show-all__btn"
                        onClick={() => {
                          if (showAllFields) {
                            handleClickShowAllFields(false);
                          } else {
                            handleClickShowAllFields(true);
                          }
                        }}
                      >
                        {showAllFields
                          ? "Скрыть параметры"
                          : "Показать еще параметры"}
                        <Icon type={showAllFields ? "up" : "down"} />
                      </div>
                    </div>
                  )
                }
              />
            </>
          ) : (
            <>
              <RequestNumber form={form} disabled={true} />
              <OfferNumber form={form} disabled={true} />
              <Customer form={form} disabled={true} />
              <Phone form={form} disabled={true} />
              <Email form={form} disabled={true} />
              <ServiceType form={form} disabled={true} />
              <Divider />
              <Routes form={form} disabled={true} />
              <Divider />
              <Performer form={form} disabled={!isEditable} />
              <Dispatcher form={form} disabled={!isEditable} />
              <VehicleTypes form={form} disabled={!isEditable} />
              <Vehicle form={form} disabled={!isEditable} />
              <Drivers form={form} disabled={!isEditable} />
              <OfferEndDateTime form={form} disabled={!isEditable} />
            </>
          )}
          {/* условие для показа полей в режиме просмотра карточки с открытыми полями*/}
          {typeForm === "view" && showAllFields ? (
            <Fragment>
              <Divider />
              <MonetizationTemplates
                form={form}
                disabled={!isEditable}
                toggleMonetizationFields={this.toggleMonetizationFields}
                passMonetizationSection={this.passMonetizationSection}
                monetizationSectionPass={this.state.monetizationSectionPass}
              />
              <Monetization
                form={form}
                disabled={!isEditable || !this.state.monetizationFieldsDisabled}
                disabledKp1urc={!isEditable}
                monetizationSectionPass={this.state.monetizationSectionPass}
              />
              <Divider />
              <PriceNoNds form={form} disabled={!isEditable} />
              <AdditionalServices form={form} disabled={!isEditable} />
              <PriceFinal form={form} disabled={true} />
              <PriceFinalNDS form={form} disabled={true} />
              <TotalPrice form={form} disabled={true} />
              <Divider />
              <OfferPaymentType
                form={form}
                disabled={!isEditable}
                sumUndestributedPrice={sumUndestributedPrice(
                  totalPrice,
                  paySum,
                  predPaySum,
                  postPaySum
                )}
              />
              <SurchargePayment form={form} disabled={!isEditable} />
              <SurchargePaymentDate form={form} disabled={!isEditable} />
              <RefundFreighterDate form={form} disabled={!isEditable} />
              <Divider />
              <OfferDocuments form={form} disabled={!isEditable} />
              <Divider />
              <CarrierComment form={form} disabled={!isEditable} />
            </Fragment>
          ) : typeForm === "edit" ? (
            <Fragment>
              <Divider />
              <MonetizationTemplates
                form={form}
                disabled={!isEditable}
                toggleMonetizationFields={this.toggleMonetizationFields}
              />
              <Monetization
                form={form}
                disabled={!isEditable || !monetizationFieldsDisabled}
                disabledKp1urc={!isEditable}
              />
              <Divider />
              <PriceNoNds form={form} disabled={!isEditable} />
              <AdditionalServices form={form} disabled={!isEditable} />
              <PriceFinal form={form} disabled={true} />
              <PriceFinalNDS form={form} disabled={true} />
              <TotalPrice form={form} disabled={true} />
              <Divider />
              <OfferPaymentType
                form={form}
                disabled={!isEditable}
                sumUndestributedPrice={sumUndestributedPrice(
                  totalPrice,
                  paySum,
                  predPaySum,
                  postPaySum
                )}
              />
              <Divider />
              <SurchargePayment form={form} disabled={!isEditable} />
              <SurchargePaymentDate form={form} disabled={!isEditable} />
              <RefundFreighterDate form={form} disabled={!isEditable} />
              <Divider />
              <OfferDocuments form={form} disabled={!isEditable} />
              <Divider />
              <CarrierComment form={form} disabled={!isEditable} />
            </Fragment>
          ) : null}
        </Form>
        {typeForm === "view" && showAllFields && (
          <div className="show-all">
            <div
              className="show-all__btn"
              onClick={() => {
                if (showAllFields) {
                  handleClickShowAllFields(false);
                } else {
                  handleClickShowAllFields(true);
                }
              }}
            >
              {showAllFields ? "Скрыть параметры" : "Показать еще параметры"}
              <Icon type={showAllFields ? "up" : "down"} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

class OfferInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    };
  }

  componentDidMount() {
    this.initEditing();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isEditable !== prevProps.isEditable) {
      this.initEditing();
    }
  }

  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      if (moment.isMoment(val)) {
        return val;
      } else {
        return val && moment(val);
      }
    } else {
      return val;
    }
  }

  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  handleFieldsChange = values => {
    // Если есть серверные ошибки, и это поле изменилось, то удаляем ошибку из store
    if (this.props.createErrors) {
      Object.keys(values).forEach(name => {
        if (
          this.props.createErrors &&
          this.props.createErrors.data &&
          this.props.createErrors.data[name]
        ) {
          if (values[name].errors) {
            delete values[name].errors;
          }
          this.props.clearError(name);
        }
      });
    }

    this.setState(
      state => {
        return {
          data: {
            ...state.data,
            ...values
          }
        };
      },
      () => {
        this.changeValues(this.state.data);
      }
    );
  };

  initEditing = () => {
    if (this.props.isEditable) {
      let newEditData = {};
      const data = this.props.offer;
      if (data) {
        Object.keys(data).forEach(item => {
          newEditData[item] = Form.createFormField({
            value: this.getValueByFieldName(item, data[item])
          });
        });
      }
      this.setState({ data: newEditData }, () => {
        this.props.updateProgress(this.formRef.getFieldsValue());
      });
    } else {
      this.setState({ data: null });
    }
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  render() {
    const { isEditable } = this.props;
    const data = isEditable ? this.state.data : this.props.offer;
    return (
      <FormOfferInfo
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
      />
    );
  }
}

const FormOfferInfo = Form.create({
  name: "formOfferInfo",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        /* todo разобраться с серверыными ошибками*/
        let err = {};
        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }

        let all = true;
        // Монетизация
        if (name === "monetization" && props.data[name]) {
          all = false;
          const {
            name: monetizationName = null,
            template: monetizationTemplate = null
          } = props.data[name];
          obj[name + ".name"] = Form.createFormField({
            value: props.isEditable
              ? monetizationName && monetizationName.value
              : monetizationName
          });
          if (monetizationTemplate) {
            Object.keys(monetizationTemplate).forEach(key => {
              let keyName = name + ".template." + key;
              if (
                monetizationTemplate[key] &&
                monetizationTemplate[key].constructor === Object
              ) {
                Object.keys(monetizationTemplate[key]).forEach(key2 => {
                  obj[keyName + "." + key2] = Form.createFormField({
                    value: props.isEditable
                      ? monetizationTemplate[key][key2].value
                      : monetizationTemplate[key][key2]
                  });
                });
              } else {
                obj[keyName] = Form.createFormField({
                  value: props.getValueByFieldName(
                    keyName,
                    props.isEditable
                      ? monetizationTemplate[key].value
                      : monetizationTemplate[key]
                  )
                });
              }
            });
          }
        }

        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            ...(props.isEditable ? err : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            )
          });
        }

        // На этапе маппинга локального стейта я вкорячиваю значения в поля, которые считаются динамически.
        // как-то так. ¯\_(ツ)_/¯
        if (name === "priceNoNds" && props.data[name]) {
          let priceFinal = props.isEditable
            ? props.data[name].value
            : props.data[name];

          const nds =
            props.performers &&
            props.performers.find(item =>
              props.isEditable
                ? item.companyId === props.data["performer"].value
                : item.companyId === props.data["performer"]
            ) &&
            !!props.performers.find(item =>
              props.isEditable
                ? item.companyId === props.data["performer"].value
                : item.companyId === props.data["performer"]
            ).nds;
          if (props.data.hasOwnProperty("additionalServices")) {
            if (props.isEditable) {
              props.data["additionalServices"].value.forEach(item => {
                const servicePrice =
                  props.data["serviceAdditionalPrice" + item].value;
                if (servicePrice) {
                  priceFinal += parseInt(servicePrice);
                }
              });
            } else {
              props.data["additionalServices"].forEach(item => {
                const servicePrice =
                  props.data["serviceAdditionalPrice" + item];
                if (servicePrice) {
                  priceFinal += parseInt(servicePrice);
                }
              });
            }
          }
          const totalPrice = nds
            ? priceFinal + Math.round(priceFinal * 0.2)
            : priceFinal;

          obj["priceFinal"] = Form.createFormField({
            value: props.getValueByFieldName(name, priceFinal)
          });
          obj["priceFinalNDS"] = Form.createFormField({
            value: props.getValueByFieldName(
              name,
              nds ? Math.round(priceFinal * 0.2) : 0
            )
          });
          obj["totalPrice"] = Form.createFormField({
            value: props.getValueByFieldName(name, totalPrice)
          });
        }
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(OfferInfo);

export default OfferInfoData;
